import { AnchorProps, Text } from "@mantine/core"
import { LinkAnchor } from "../../../../../-components/link-anchor"
import { useBatchedProductionPermissions } from "../../../../../../../-dataloaders/production-permissions"
import { PermissionType_AllValues } from "../../../../../../../@client/Theasoft_Data_Permissions"

interface RoleLinkProps {
  productionId: number
  roleId: number
  name: React.ReactNode
}

export function RoleLink({
  productionId,
  roleId,
  name,
  ...props
}: RoleLinkProps & AnchorProps) {
  const { data: permission } = useBatchedProductionPermissions(productionId)
  return permission !== PermissionType_AllValues[0] ? (
    <LinkAnchor
      c={props.c || "var(--mantine-color-text)"}
      underline={props.underline || "hover"}
      to="/app/art/productions/$id/$roleId"
      params={{ id: productionId.toString(), roleId: roleId.toString() }}
      search={{ tab: "start", seasonFilter: undefined }}
      {...props}
    >
      {name}
    </LinkAnchor>
  ) : (
    <Text {...props}>{name}</Text>
  )
}
